import React, { memo, useRef } from 'react'
import { Form, Row, Col } from 'react-bootstrap'

const CreditsData = memo(({
  position,
  handleChangePositionByKey,
  formErrors,
  index,
}) => {
  const ref = useRef()
  const handleChange = (e) => {
    const { name } = e.target
    e.preventDefault()
    var newValues = [...position.credits]
    let foundIndex = newValues.findIndex(e => e.id === name);
    if (foundIndex > -1) {
        newValues[foundIndex].isSelected = e.target.checked
    } 
    handleChangePositionByKey(position.id, "credits", newValues)
  }
  const disabled = position.metaProperties && position.metaProperties.find(metaProp => (metaProp.pointer === '/credits' && metaProp.attributes === 'isReadOnly'))
  const renderItem = (item, itemIndex) => {
    return (
      <>
        <Col sm="6" lg="3">
          <Form.Group className="mb-3">
            <Form.Check
                id={`positions${index}credits${itemIndex}`}
                label={item.displayName}
                type="checkbox"
                name={item.id}
                onChange={handleChange}
                checked={item.isSelected}
                disabled={disabled}
            />
          </Form.Group>
        </Col>
      </>
    )
}
  return (
    <div ref={ref}>
      <div className="spacing-down">
        <Row>
          {position.credits.map((item, index) => renderItem(item, index))}
        </Row>
      </div>
    </div>
  )
})

export default CreditsData
